/**
 * @generated SignedSource<<b44ba82e501843b2d4fda34a4759a35f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecruitMatch_viewer$data = {
  readonly user: {
    readonly isStaff: boolean;
    readonly profile: {
      readonly tenant: {
        readonly enablePanelExport: boolean;
      };
    } | null;
  } | null;
  readonly " $fragmentType": "RecruitMatch_viewer";
};
export type RecruitMatch_viewer$key = {
  readonly " $data"?: RecruitMatch_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecruitMatch_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecruitMatch_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserNode",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isStaff",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProfileNode",
          "kind": "LinkedField",
          "name": "profile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TenantNode",
              "kind": "LinkedField",
              "name": "tenant",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "enablePanelExport",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "da556c96c26081e7931f63e14e870397";

export default node;
